import React, { forwardRef } from "react";

const TextButton = forwardRef((props, ref) => {

    const { onClick = () => { }, onEnter = () => { }, style = {} } = props;

    return (<div style={style} onKeyDown={(e) => { if (e.key === "Enter") { onClick(e) } }} ref={ref} tabIndex={0} role="button" onClick={onClick} className="ui-text-button">{props.children}</div>)
});

export default TextButton;